// Class: swf.exporters.swflite.SWFSymbol

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $hxEnums = require("./../../../hxEnums_stub").default;

// Constructor

var SWFSymbol = function() {
}

// Meta

SWFSymbol.__name__ = "swf.exporters.swflite.SWFSymbol";
SWFSymbol.__isInterface__ = false;
SWFSymbol.prototype = {
	__createObject: function(swf1) {
		return null;
	},
	__init: function(swf1) {
	},
	__initObject: function(swf1,instance) {
	}
};
SWFSymbol.prototype.__class__ = SWFSymbol.prototype.constructor = $hxClasses["swf.exporters.swflite.SWFSymbol"] = SWFSymbol;

// Init



// Statics




// Export

exports.default = SWFSymbol;